import {
    Box,
    Typography,
} from '@mui/material';
import WebPresenceCard from './WebPresenceCard';
import MainWebsiteCard from '../MainWebsiteTab/MainWebsiteCard';
import { colors } from '../../styles/globals.js';
import { AddWebPresenceButton, RemoveWebPresenceButton } from '../EditMode/CompanyDetailEditControls';
import WebPresenceAssessmentEditor from '../EditMode/WebPresenceAssessmentEditor';

const WebPresenceTab = ({ web_presence, onUpdateWebPresence }) => {
    const web_presence_data = web_presence.filter(item => item.type !== 'DOMAIN')


    if (!web_presence_data || web_presence_data.length === 0) {
        return (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography sx={{ color: colors.textSecondary }}>
                    No web presence found
                </Typography>
                {onUpdateWebPresence && (
                    <Box sx={{ mt: 2 }}>
                        <AddWebPresenceButton webPresence={web_presence} onUpdate={onUpdateWebPresence} />
                    </Box>
                )}
            </Box>
        );
    }


    // Sample data for the cards matching screenshot
    const linkedInStatusItems = [
        { type: 'warning', text: 'Multiple redirects detected' },
        { type: 'warning', text: 'Generic language used' },
        { type: 'success', text: 'Valid domain registration' },
        { type: 'success', text: 'Website is active' }
    ];

    const youTubeStatusItems = [
        { type: 'success', text: 'Active channel found' },
        { type: 'success', text: 'Recent uploads detected' },
        { type: 'warning', text: 'Limited subscriber count' }
    ];

    const websiteStatusItems = [
        { type: 'warning', text: 'Multiple redirects detected' },
        { type: 'success', text: 'Valid domain registration' },
        { type: 'success', text: 'Website is active' }
    ];

    const mainWebsiteStatusItems = [
        { type: 'warning', text: 'Multiple redirects detected' },
        { type: 'success', text: 'Valid domain registration' },
        { type: 'success', text: 'Website is active' }
    ];


    console.log('web_presence_data', web_presence_data);

    // Find all instances of each platform type from the data
    const facebookItems = web_presence_data.filter(item => item.type === 'FACEBOOK');
    const instagramItems = web_presence_data.filter(item => item.type === 'INSTAGRAM');
    const twitterItems = web_presence_data.filter(item => item.type === 'TWITTER');
    const yelpItems = web_presence_data.filter(item => item.type === 'YELP');
    const googleMapsItems = web_presence_data.filter(item => item.type === 'GOOGLE_MAPS');
    const mapquestItems = web_presence_data.filter(item => item.type === 'MAPQUEST');
    const youTubeItems = web_presence_data.filter(item => item.type === 'YOUTUBE');
    const linkedInItems = web_presence_data.filter(item => item.type === 'LINKEDIN');
    const yellowPagesItems = web_presence_data.filter(item => item.type === 'YELLOWPAGES');

    const webPresenceItems = web_presence_data.filter(item =>
        item.type !== 'FACEBOOK' &&
        item.type !== 'INSTAGRAM' &&
        item.type !== 'TWITTER' &&
        item.type !== 'YELP' &&
        item.type !== 'GOOGLE_MAPS' &&
        item.type !== 'MAPQUEST' &&
        item.type !== 'YOUTUBE' &&
        item.type !== 'LINKEDIN' &&
        item.type !== 'YELLOWPAGES' &&
        item.type !== 'DOMAIN'
    );

    const renderPlatformCards = (items, title, platform) =>
        items.map((item) => (
            <Box key={item.id} sx={{ position: 'relative' }}>
                <WebPresenceCard title={title} platform={platform} riskLevel={null} url={item?.value} statusItems={[]} assessments={item?.assessments} width={340} source={item?.source} />
                {onUpdateWebPresence && (
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <RemoveWebPresenceButton itemId={item.id} webPresence={web_presence} onUpdate={onUpdateWebPresence} />
                        <WebPresenceAssessmentEditor item={item} webPresence={web_presence} onUpdate={onUpdateWebPresence} />
                    </Box>
                )}
            </Box>
        ));

    return (
        <Box>
            {onUpdateWebPresence && (
                <Box sx={{ mb: 2 }}>
                    <AddWebPresenceButton webPresence={web_presence} onUpdate={onUpdateWebPresence} />
                </Box>
            )}
            {/* Web Presence Cards */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'flex-start', mb: 3 }}>
                {renderPlatformCards(linkedInItems, "LinkedIn", "linkedin")}
                {renderPlatformCards(youTubeItems, "YouTube", "youtube")}
                {renderPlatformCards(facebookItems, "Facebook", "facebook")}
                {renderPlatformCards(instagramItems, "Instagram", "instagram")}
                {renderPlatformCards(twitterItems, "Twitter", "twitter")}
                {renderPlatformCards(yelpItems, "Yelp", "yelp")}
                {renderPlatformCards(googleMapsItems, "Google Maps", "google_maps")}
                {renderPlatformCards(mapquestItems, "Mapquest", "mapquest")}
                {renderPlatformCards(yellowPagesItems, "Yellow Pages", "yellow_pages")}
                {renderPlatformCards(webPresenceItems, "Web Presence", "web_presence")}
            </Box>
        </Box>
    );
};

export default WebPresenceTab;